import React, { Fragment, useState } from 'react'
import LocalidadesDeLaZonaListItemComponent from './LocalidadesDeLaZonaListItemComponent';


function LocalidadesDeLaZonaListComponent(props) {

    const localidades = props.localidades;
    const zona = props.zona

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        overflow: 'scroll',
        height: '100%',
    };

    React.useEffect(() => {
        localidades
    }, [localidades])

    React.useEffect(() => {
        zona
    }, [zona])

    React.useEffect(() => {

    }, [])

    return (
        <Fragment>
            <div className='row'>
                <div className='col-md-8' style={{ textAlign: 'left' }}>
                    <h5><strong>Localidad:</strong></h5>
                </div>
                <div className='col-md-4' style={{ textAlign: 'left' }}>
                    <h5><strong>Opciones:</strong></h5>
                </div>
            </div>



            {
                localidades.map((localidad, index) => (
                    <LocalidadesDeLaZonaListItemComponent actualizarZonas={props.actualizarZonas} handleClose={props.handleClose} onEditarLocalidad={props.onEditarLocalidad} key={index} localidad={localidad} zona={zona} ></LocalidadesDeLaZonaListItemComponent>
                ))
            }

        </Fragment >
    )
}

export default LocalidadesDeLaZonaListComponent